import type { Langcode } from '#nuxt-language-negotiation/config'

export function getLanguageFromPath(path = ''): string | undefined {
  if (!path) {
    return
  }
  const matches = /^\/(de|fr|en)(\/|$)/.exec(path)
  return matches?.[1] as Langcode
}
